import { gql } from "@apollo/client";
import { SearchSelect } from "./SearchSelect";
import { AdSearchSelect_SearchAdsQuery } from "../../../../codegen/graphql";
import client from "../../../graphqlClient";

const SEARCH_ADS = gql`
  query AdSearchSelect_SearchAds($search: String!) {
    ads(search: $search, page: 1, pageSize: 10) {
      nodes {
        id
        title
      }
    }
  }
`;

export type AdSearchSelect_AdOption = AdSearchSelect_SearchAdsQuery['ads']['nodes'][number];

export default function AdSearchSelect({
  selectedAd,
  onAdChange,
}: {
  selectedAd: AdSearchSelect_AdOption | null;
  onAdChange: (ad: AdSearchSelect_AdOption | null) => void;
}) {
  // Load ads for search
  const loadAds = async (searchText: string) => {
    if (searchText.trim().length < 2) return [];
    
    const result = await client.query({
      query: SEARCH_ADS,
      variables: { search: searchText },
      fetchPolicy: 'network-only'
    });

    if (!result.data) {
      throw result.errors;
    }

    return result.data.ads.nodes;
  };

  return (
    <SearchSelect<AdSearchSelect_AdOption>
      loadOptions={loadAds}
      value={selectedAd || null}
      onSelect={(option) => onAdChange(option)}
      onClear={() => onAdChange(null)}
      renderOption={(option, selectCallback) => (
        <div key={option.id} className='px-2 py-1' onClick={selectCallback}>
          {option.title[Object.keys(option.title)[0]]}
        </div>
      )}
      renderSelected={(option) => option.title[Object.keys(option.title)[0]]}
      label="Product"
      placeholder="Search for a product..."
    />
  )
}